import styled from '@emotion/styled';
import { alpha, Button } from '@mui/material';
import { shouldForwardProps } from '@dh/utils';
import { ButtonLabel } from '@dh/styles';

const WhiteButtonWrapper = styled(Button, shouldForwardProps)<{
    isBig?: boolean;
    fullWidth?: boolean;
    themeColor?: string;
}>`
    background-color: ${({ theme, disabled, themeColor }) =>
        disabled
            ? theme.colors.disabled
            : themeColor
              ? alpha(themeColor, 0.8)
              : theme.colors.white};
    border-radius: 8px;
    padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};
    height: ${({ isBig }) => (isBig ? '56px' : '40px')};
    clip-path: inset(-4px);
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};

    &:hover {
        background-color: ${({ theme, themeColor }) =>
            themeColor ? alpha(themeColor, 0.7) : theme.colors.primaryContainer};
    }

    &:focus {
        background-color: ${({ theme, themeColor }) =>
            themeColor ? alpha(themeColor, 0.7) : theme.colors.primaryContainer};
        border: 2px solid ${({ theme }) => theme.colors.onSurface};
        border-radius: 8px;
        box-shadow:
            0 0 0 2px
                ${({ theme, themeColor }) =>
                    themeColor ?? theme.colors.primaryContainer},
            0 0 0 4px
                ${({ theme, themeColor }) =>
                    themeColor ? alpha(themeColor, 0.4) : alpha(theme.colors.primary, 0.4)};
    }
`;

const WhiteButtonLabel = styled(ButtonLabel, shouldForwardProps)<{
    hasIcon?: boolean;
    isDisabled?: boolean;
}>`
    margin-left: ${({ hasIcon, theme }) => (hasIcon ? theme.spacing(1) : 0)};
    color: ${({ theme, isDisabled }) =>
        isDisabled ? theme.colors.disabledText : theme.colors.onSurface};
`;

export { WhiteButtonWrapper, WhiteButtonLabel };
